<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="modal hide fade" id="modalSalePrint" tabindex="-1" role="dialog" aria-labelledby="modalSalePrint" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                      <h4 class="modal-title">
                        Print Preview
                      </h4>
                      <button type="button" class="btn btn-sm btn-primary ml-1" @click="getInvoice">Get</button>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div class="modal-body">
                    <div class="embed-responsive embed-responsive-16by9">
                      <iframe id="file" width="980" height="600"></iframe>
                    </div>
                    <!-- <div class="row">
                      <div class="col-md-6"><pre>{{ sales }}</pre></div>
                      <div class="col-md-6"><pre>{{ group }}</pre></div>
                    </div> -->
                  </div>
            </div>
          </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import { sale2Url } from '../../config'
import Loading from 'vue-loading-overlay'

export default {
  name: 'SalePrintModal',
  props: ['sales', 'group'],
  components: {
    Loading
  },
  data () {
    return {
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: false,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      }
    }
  },
  methods: {
    async getInvoice () {
      this.$Progress.start()
      this.loader.isLoading = true
      const data = {
        id: this.sales.id,
        format: null,
        data: this.group,
        status: 'preview'
      }
      const url = sale2Url + '/invoice2'
      axios.post(url, data, { responseType: 'blob' })
        .then(response => {
          const imageNode = document.getElementById('file')
          const imgUrl = URL.createObjectURL(response.data)
          imageNode.src = imgUrl + '#toolbar=0'
          console.log(imgUrl + '#toolbar=0')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    }
  }
}
</script>
